export default function Products() {
  const products = [
    {
      id: 1,
      name: 'VPN Application',
      description: 'Secure your online presence with our advanced VPN solution. Protect your privacy, encrypt your data, and browse the internet safely from anywhere in the world.',
      features: [
        'Military-grade encryption',
        'Global server network',
        'Zero-log policy',
        'Lightning-fast connection',
        'Kill switch protection',
        'Multi-device support'
      ],
      icon: 'ri-shield-check-line',
      image: 'https://public.readdy.ai/ai/img_res/6788333c5906b82eb159c41d5480ad20.jpg',
      color: 'teal'
    },
    {
      id: 2,
      name: 'Cleaner Application',
      description: 'Optimize your iOS device performance with our intelligent cleaner app. Remove junk files, manage storage efficiently, and keep your device running smoothly.',
      features: [
        'Smart storage analysis',
        'Duplicate file detection',
        'Photo compression',
        'Cache cleaning',
        'Battery optimization',
        'Privacy protection'
      ],
      icon: 'ri-brush-line',
      image: 'https://readdy.ai/api/search-image?query=modern%20smartphone%20showing%20storage%20optimization%20interface%20with%20clean%20minimalist%20design%20displaying%20storage%20bars%20and%20cleaning%20progress%20on%20white%20background%20with%20green%20and%20teal%20accent%20colors%20professional%20product%20shot%20illustrating%20device%20performance%20improvement%20high%20quality%20render&width=600&height=400&seq=cleaner-product-001&orientation=landscape',
      color: 'emerald'
    }
  ];

  return (
    <section id="products" className="py-24 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Our Products
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Discover our suite of powerful iOS applications designed to enhance your mobile experience
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          {products.map((product) => (
            <div
              key={product.id}
              className="bg-white rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 overflow-hidden group"
              data-product-shop
            >
              <div className="relative h-64 overflow-hidden">
                <img
                  src={product.image}
                  alt={product.name}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className={`absolute top-4 right-4 w-12 h-12 bg-${product.color}-500 rounded-full flex items-center justify-center shadow-lg`}>
                  <i className={`${product.icon} text-2xl text-white`}></i>
                </div>
              </div>
              
              <div className="p-8">
                <h3 className="text-2xl font-bold text-gray-900 mb-3">
                  {product.name}
                </h3>
                <p className="text-gray-600 mb-6 leading-relaxed">
                  {product.description}
                </p>
                
                <div className="space-y-3">
                  <h4 className="text-sm font-semibold text-gray-900 uppercase tracking-wide">
                    Key Features
                  </h4>
                  <ul className="grid grid-cols-2 gap-3">
                    {product.features.map((feature, index) => (
                      <li key={index} className="flex items-start gap-2">
                        <i className={`ri-check-line text-${product.color}-500 text-lg mt-0.5 flex-shrink-0`}></i>
                        <span className="text-sm text-gray-700">{feature}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
